// extracted by mini-css-extract-plugin
module.exports = {"pressInfo":"PressInfo_pressInfo__1bHqH","button":"PressInfo_button__1A1aW","info":"PressInfo_info__2J_5r","img":"PressInfo_img__3Kd4O","perssInfo":"PressInfo_perssInfo__qKU-w"};